// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"NP-z","carouselContainer":"OP-z"};